import { render, staticRenderFns } from "./xiaoMiQueue.vue?vue&type=template&id=36af2f8a"
import script from "./xiaoMiQueue.vue?vue&type=script&lang=js"
export * from "./xiaoMiQueue.vue?vue&type=script&lang=js"
import style0 from "./xiaoMiQueue.vue?vue&type=style&index=0&id=36af2f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports